// Generate time options in 15-minute increments
export const generateTimeOptions = () => {
  const times = [];
  
  // AM times (starting at 6 AM)
  for (let hour = 6; hour < 12; hour++) {
    for (let minute of [0, 15, 30, 45]) {
      const displayHour = hour === 0 ? 12 : hour;
      const timeString = `${displayHour}:${minute.toString().padStart(2, '0')} AM`;
      times.push(timeString);
    }
  }
  
  // PM times (up to 8 PM)
  for (let hour = 0; hour <= 8; hour++) {
    for (let minute of [0, 15, 30, 45]) {
      const displayHour = hour === 0 ? 12 : hour;
      const timeString = `${displayHour}:${minute.toString().padStart(2, '0')} PM`;
      times.push(timeString);
    }
  }
  
  return times;
};

// Parse time string to Date object
export const parseTime = (timeStr) => {
  if (!timeStr) return null;
  
  const timeFormats = [
    /(\d{1,2}):(\d{2})\s*(AM|PM)/i,  // 8:00 AM
    /(\d{1,2}):(\d{2})(AM|PM)/i,     // 8:00AM
  ];
  
  for (let format of timeFormats) {
    const match = timeStr.match(format);
    if (match) {
      let hours = parseInt(match[1]);
      const minutes = parseInt(match[2]);
      const period = match[3].toUpperCase();
      
      if (period === 'PM' && hours !== 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }
      
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
      return date;
    }
  }
  
  return null;
};

// Calculate duration in hours
export const calculateDuration = (startTime, endTime) => {
  const start = parseTime(startTime);
  const end = parseTime(endTime);
  
  if (!start || !end) return 0;
  
  let duration = (end - start) / (1000 * 60 * 60);
  
  // If end is before start, assume next day
  if (duration < 0) {
    duration += 24;
  }
  
  return Math.round(duration * 100) / 100;
};

// Format duration as HH:MM
export const formatDuration = (hours) => {
  const totalMinutes = Math.round(hours * 60);
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return `${hrs}:${mins.toString().padStart(2, '0')}`;
};

// Get start of week (Sunday)
export const getStartOfWeek = (date = new Date()) => {
  const day = date.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const diff = date.getDate() - day; // Go back to Sunday
  const sunday = new Date(date.setDate(diff));
  sunday.setHours(0, 0, 0, 0);
  return sunday;
};

// Format date as YYYY-MM-DD
export const formatDate = (date) => {
  if (!date) return '';
  if (typeof date === 'string') return date;
  
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// === Date Utilities for Time Tracking ===

/**
 * Parse entry.start_date into a local Date object
 * Ignores any timezone information (e.g., UTC 'Z' or offsets)
 */
export function parseEntryDate(entry) {
  if (!entry?.start_date) return null;
  const iso = entry.start_date.split('T')[0];
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/**
 * Check if a date falls within a given week (inclusive)
 * All comparisons are local, ignoring timezones
 */
export function isWithinWeek(entryDate, weekStart, weekEnd) {
  if (!(entryDate instanceof Date) || isNaN(entryDate)) return false;

  const entryDay = new Date(entryDate.getFullYear(), entryDate.getMonth(), entryDate.getDate());
  const startDay = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate());
  const endDay = new Date(weekEnd.getFullYear(), weekEnd.getMonth(), weekEnd.getDate());

  return entryDay >= startDay && entryDay <= endDay;
}
